<template>
    <div class="user">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2">
                    <nacUser></nacUser>
                </b-col>
                <b-col cols="12" md="10">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">課程收藏</span>
                        </template>
                        <div v-if="TablePage.items.length > 0" class="responsive">
                            <div class="mb-3">
                                <b-form-input v-model="keywordInput" placeholder="課程名稱搜尋"></b-form-input>
                            </div>
                            <BTableV1 :TablePage="TablePage" :cell="['FavoriteHeart', 'FavoriteCreate', 'ApplyDate', 'Price', 'Enable', 'tool']">
                                <template #FavoriteHeart="{ row }">
                                    <b-button
                                        variant="link"
                                        size="sm"
                                        class="p-0 favorite-heart-button"
                                        :disabled="isFavoritePending(row.item)"
                                        @click.stop.prevent="toggleFavoriteAndRefresh(row.item)"
                                    >
                                        <b-icon-heart-fill
                                            v-if="isFavorite(row.item)"
                                            variant="danger"
                                            font-scale="1.2"
                                        ></b-icon-heart-fill>
                                        <b-icon-heart
                                            v-else
                                            variant="danger"
                                            font-scale="1.2"
                                        ></b-icon-heart>
                                    </b-button>
                                </template>
                                <template #FavoriteCreate="{ row }">
                                    {{ row.item.FavoriteCreate | datefmt('YYYY-MM-DD') }}
                                    <br />
                                    {{ row.item.FavoriteCreate | datefmt('HH:mm:ss') }}
                                </template>
                                <template #ApplyDate="{ row }">
                                    <span v-if="row.item.ApplyStart || row.item.ApplyEnd">
                                        {{ row.item.ApplyStart | datefmt('YYYY-MM-DD') }}
                                        <span> ~ </span>
                                        {{ row.item.ApplyEnd | datefmt('YYYY-MM-DD') }}
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template #Price="{ row }">
                                    {{ row.item.Price | money(0, 2) }}
                                </template>
                                <template #Enable="{ row }">
                                    <b-badge :variant="row.item.Enable ? 'success' : 'secondary'">
                                        {{ row.item.Enable ? '開放中' : '未開放' }}
                                    </b-badge>
                                </template>
                                <template #tool="{ row }">
                                    <b-button variant="primary" size="sm" @click="goCourse(row.item)">查看課程</b-button>
                                </template>
                            </BTableV1>
                        </div>
                        <template v-else>
                            <b-alert show variant="light" class="text-center mb-3">
                                目前沒有課程喜好清單。
                            </b-alert>
                            <div class="text-center">
                                <b-button variant="primary" @click="_go('/courses')">瀏覽課程</b-button>
                            </div>
                        </template>
                        <template v-if="TablePage.items.length > 0">
                            <div class="overflow-auto mt-5">
                                <b-pagination
                                    align="center"
                                    v-model="Param.Paging.pageNumber"
                                    :total-rows="rows"
                                    :per-page="Param.Paging.pageSize"
                                ></b-pagination>
                            </div>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import nacUser from '@/components/nacUser.vue';
import BTableV1 from '../../components/BTableV1.vue';
import courseFavorite from '@/mixins/courseFavorite.js';
import { apiFavoriteProductList } from '@/api/API.js';

export default {
    name: 'user-favorite',
    mixins: [courseFavorite],
    components: {
        nacUser,
        BTableV1,
    },
    data() {
        return {
            Param: {
                Paging: {
                    pageNumber: 1,
                    pageSize: 10,
                },
                Search: {
                    keywords: '',
                },
            },
            keywordInput: '',
            pageHeader: '',
            rows: 0,
            title: '課程收藏',
            TablePage: {
                title: '',
                class: '',
                BT_style: { striped: true, hover: true },
                PG_style: {
                    pills: true,
                    align: 'center',
                    'first-text': '第一頁',
                    'prev-text': '上一頁',
                    'next-text': '下一頁',
                    'last-text': '最末頁',
                },
                itemsAll: [],
                items: [],
                id: 'FavoriteTable',
                currentPage: 1,
                rows: 100,
                page: 10,
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                fields: [
                    { key: 'FavoriteHeart', label: '' },
                    { key: 'FavoriteCreate', label: '收藏日期' },
                    { key: 'Title', label: '課程名稱', sortable: false },
                    { key: 'ApplyDate', label: '報名期間', sortable: false },
                    { key: 'Price', label: '課程價格', sortable: false },
                    { key: 'Enable', label: '狀態', sortable: false },
                    { key: 'tool', label: '操作', sortable: false },
                ],

                TIndex(th1, index) {
                    return (th1.currentPage - 1) * th1.page + index;
                },
                clear(th1) {
                    th1.itemsAll = [];
                    th1.items = [];
                    th1.rows = 0;
                    th1.currentPage = 1;
                },
                set(th1, data) {
                    th1.itemsAll = JSON.parse(JSON.stringify(data));
                    th1.items = JSON.parse(JSON.stringify(data));
                    th1.rows = data.length;
                },
                set2(th1, data) {
                    th1.items = JSON.parse(JSON.stringify(data));
                    th1.rows = data.length;
                    th1.currentPage = 1;
                },
                set3(th1, data) {
                    th1.items = JSON.parse(JSON.stringify(data));
                    th1.rows = data.length;
                    th1.currentPage = 1;
                },
            },
        };
    },
    watch: {
        'Param.Paging.pageNumber'(newVal) {
            if (newVal) {
                this.GetList(newVal);
            }
        },
        keywordInput(newVal) {
            this.Param.Search.keywords = encodeURI(newVal || '');
            this.GetList(1);
        },
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('請先登入');
            this._go('/');
        }
        this.Init();
    },
    methods: {
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
        async toggleFavoriteAndRefresh(item) {
            const wasFavorite = this.isFavorite(item);

            await this.toggleFavorite(item);

            if (!wasFavorite || this.isFavorite(item)) {
                return;
            }

            const targetPage =
                this.TablePage.items.length === 1 && this.Param.Paging.pageNumber > 1
                    ? this.Param.Paging.pageNumber - 1
                    : this.Param.Paging.pageNumber;

            this.GetList(targetPage);
        },
        goCourse(item) {
            const courseId = item?.ClassId || item?.ProductId;
            if (!courseId) {
                return;
            }
            this._go(this.LocaPath.default + 'course?Id=' + courseId);
        },
        async Init() {
            await this.loadFavoriteProducts();
            this.GetList();
        },
        GetList(val) {
            this.TablePage.items = [];
            this.loadSet.show = true;
            if (val) {
                this.Param.Paging.pageNumber = val;
            } else {
                this.Param.Paging.pageNumber = 1;
            }
            apiFavoriteProductList(this.Param)
                .then((res) => {
                    this.TablePage.items = res.data;
                    this.setFavoriteCollections(res.data);
                    this.pageHeader = JSON.parse(res.headers['list-header']).Paging;
                    this.rows = this.pageHeader.totalCount;
                    this.loadSet.show = false;
                })
                .catch((err) => {
                    this.loadSet.show = false;
                    console.log(err.response || err);
                });
        },
    },
};
</script>
